import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'player-play', 'PlayerPlay', [["path",{"d":"M7 4v16l13 -8l-13 -8","key":"svg-0"}]]);